import Application from "airports/p11v5-nsru-api/Application";
import React from "react";
import ListGroupItem from "reactstrap/lib/ListGroupItem";
import Media from "reactstrap/lib/Media";

class AppIcon extends React.Component
{
    constructor(props) {
        super(props);
        this.className = "";
        this.className += props.withCircle ? " appIconWithCircle " : " appIconWithSquare "

        this.state = {
            name: "{app_name}",
            icon: require("assets/img/app-icon/icon-default.png"),
            link: "#"
        }
    }

    async componentDidMount() {
        let appApi = new Application()
        const response = await appApi.read(this.props.id)
        this.setState({
            name: response.name,
            icon: process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + response.icon,
            link: response.link
        })
    }

    render() {
        if(this.props.isSlim == true) {
            return (
                <>
                    <ul className="list-unstyled m-0 p-0">
                        <li className="m-0 appicon-slim-card" style={{ 
                            borderBottom: "1px solid #EEE"
                         }}>
                            <a href={this.state.link ?? "#"} target={this.props.appTarget ?? "_blank"} >
                                <div className="d-flex align-items-center pl-2 pt-1 pb-1">
                                    <div>
                                        <img
                                            alt="Application Icon"
                                            className="avatar mr-3"
                                            src={this.state.icon}
                                            style={{
                                                width: "25px",
                                                height: "25px"
                                            }}
                                        ></img>
                                    </div>
                                    <div>
                                        <h6 className="mb-1 g-font-sarabun">
                                            {this.state.name}
                                        </h6>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </>
            );
        } else {
            return (
                <>
                    <ListGroupItem
                        className=" list-group-item-action"
                        href={this.state.link ?? "#"}
                        tag="a"
                        target={this.props.appTarget ?? "_blank"}
                    >
                        <Media>
                            <img
                                alt="..."
                                className="avatar"
                                src={this.state.icon}
                            ></img>
                            <Media body className="ml-2" style={{
                                        overflow: "hidden",
                                        fontSize: "smaller"
                                    }}>
                                <div className="justify-content-between align-items-center">
                                    <h6 className="mb-0 g-font-sarabun">
                                        {this.state.name}
                                    </h6>
                                    <div>
                                        <small>{this.state.link}</small>
                                    </div>
                                </div>
                            </Media>
                        </Media>
                    </ListGroupItem>
                </>
            );
        }
    }
}

export default AppIcon;
